module.exports = __webpack_public_path__ + "img/logo.933011ed.png";